import { Tooltip } from "@mui/material";

export const SentinelStatus = ({ sentinel }) => {
    let tip;
    const style = { marginLeft: 2 };
    if (!sentinel?.status) {
        style.color = "lightgray";
        tip = "no data yet";
    } else if (sentinel.status === "in_progress") {
        style.color = "gold";
        tip = "in progress";
    } else if (sentinel.error) {
        style.color = "red";
        tip = "failed to download satellite data";
    } else if (!sentinel.date) {
        style.color = "lightgray";
        style.textDecoration = 'line-through black double';
        tip = "not satellite data available";
    } else {
        style.color = "ForestGreen";
    }
    const status = <span className="fa fa-satellite" style={style} />;
    if (tip) return <Tooltip title={tip}>{status}</Tooltip>;
    return status;
};


export const SoilStatus = ({ soil, property, icon }) => {
    let tip;
    const style = { marginLeft: 2 };
    if (property === "sampling_path" && soil?.sampling_path) {
        style.color = "ForestGreen";
    } else if (!soil?.status || soil?.recalculate) {
        style.color = "lightgray";
        tip = soil?.status ? "stale data" : "no data yet";
    }
    else if (soil.status === "in_progress") {
        style.color = "gold";
        tip = "in progress";
    } else if (soil.error) {
        style.color = "red";
        tip = soil.error;
    } else if (!soil.properties?.length || property && !soil.properties.includes(property)) {
        style.color = "lightgray";
        style.textDecoration = 'line-through black double';
        tip = "not available";
    } else {
        style.color = "ForestGreen";
    }
    const status = <span className={`fa ${icon || "fa-signal"}`} style={style} />;
    if (tip) return <Tooltip title={tip}>{status}</Tooltip>;
    return status;
};
